import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { Input, Button, BannerComponent } from 'common/components';
import { AuthScreen } from 'containers';
import { email, required } from 'common/form-validators';
import {
  ROUTE_FIELDS,
  ROUTE_DASHBOARD,
  ROUTE_SIGNUP,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_CONFIRM_USER,
} from 'common/constants';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { auth } from 'actions';
import { push } from 'connected-react-router';
import queryString from 'query-string';
import { devLogger } from 'util/devLogger';
import { confirmUser } from 'api/auth';
import { FETCH_ALL_FIELDS_ONLY } from 'api/field';
import mixpanel from 'mixpanel-browser';
import './index.css';

const loginSubmitButton =
  process.env.REACT_APP_QATAG === 'true'
    ? { 'data-qa': 'login-submit-button' }
    : {};
const emailField =
  process.env.REACT_APP_QATAG === 'true'
    ? { 'data-qa': 'login-email-field' }
    : {};
const passwordField =
  process.env.REACT_APP_QATAG === 'true'
    ? { 'data-qa': 'login-password-field' }
    : {};
const errorField =
  process.env.REACT_APP_QATAG === 'true'
    ? { 'data-qa': 'login-error-field' }
    : {};
class Login extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    login: PropTypes.func.isRequired,
    goToPage: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired,
  };

  state = { error: null, message: '' };

  componentDidMount() {
    const { location } = this.props;
    if (location && location.pathname === ROUTE_CONFIRM_USER) {
      this._confirmUser();
    }
  }

  login = async ({ username, password }) => {
    try {
      await this.props.login({ username, password });
      // check if user's field list is empty
      const { data } = await this.props.client.query({
        query: FETCH_ALL_FIELDS_ONLY,
        variables: { active: true },
        fetchPolicy: 'network-only',
      });
      this.props.goToPage(
        data.getAllFields && data.getAllFields.length === 0
          ? ROUTE_FIELDS
          : ROUTE_DASHBOARD
      );
      mixpanel.identify(username.toLowerCase());
      mixpanel.people.increment('# of logins');
    } catch (error) {
      if (error && error.errors) {
        this.setState({ error: error.errors._error });
      }
    }
  };

  _confirmUser = () => {
    const { user_name, confirmation_code } = queryString.parse(
      this.props.location.search
    );
    confirmUser(user_name, confirmation_code)
      .then(data => {
        // Log the success response in dev env
        devLogger('confirmUser sucess', data);

        // Show banner with message
        this.setState(
          {
            message: 'Success! Account Confirmed. Please sign in.',
          },
          this._hideBanner()
        );
      })
      .catch(err => {
        // Log the error response in dev env
        devLogger('confirmUser error', err);

        let message = err.message || '';

        // Correct typo in AWS' error message
        if (message === 'User cannot be confirm. Current status is CONFIRMED') {
          message = 'This account has already been confirmed, please sign in.';
        }

        // Show banner with message
        this.setState({ message }, this._hideBanner());
      });
  };

  _hideBanner = (ms = 4000) => {
    this.props.goToPage('/');
    setTimeout(() => {
      this.setState({ message: '' });
    }, ms);
  };

  render() {
    const { handleSubmit, valid, pristine, submitting } = this.props;
    const { error, message } = this.state;
    return (
      <AuthScreen
        header={
          <Fragment>
            <h1 className={'text--header'}>SIGN IN</h1>
            <span className={'text---fade'}>
              or <Link to={ROUTE_SIGNUP}>Sign up</Link>
            </span>
          </Fragment>
        }
        banner={
          message && <BannerComponent message={message} theme={['strong']} />
        }
      >
        <form onSubmit={handleSubmit(this.login)}>
          <Input
            {...emailField}
            name="username"
            disabled={submitting}
            title="Email"
            validate={[email, required]}
          />

          <Input
            {...passwordField}
            name="password"
            type="password"
            title="Password"
            disabled={submitting}
            validate={[required]}
          />

          {error && (
            <p {...errorField} className="text--error">
              {error}
            </p>
          )}

          <div className={'field__group text--center'}>
            <Button
              {...loginSubmitButton}
              type="submit"
              className="btn btn--primary"
              disabled={!valid || pristine || submitting}
            >
              SIGN IN
            </Button>
            <Link to={ROUTE_FORGOT_PASSWORD} className="login__forgot-password">
              Forgot password?
            </Link>
          </div>
        </form>
      </AuthScreen>
    );
  }
}

const formSettings = {
  form: 'login', // a unique identifier for this form
  onChange: (values, dispatch, props) => {
    // do this only the server side error exists
    if (!props.error) {
      return;
    }
    // trigger change to force re-validation
    dispatch(props.change('password', values.password));
    dispatch(props.change('username', values.username));
  },
};
const mapDispatch = {
  login: auth.login,
  goToPage: routeName => push(routeName),
};

const enhance = compose(
  withApollo,
  connect(
    null,
    mapDispatch
  ),
  withRouter,
  reduxForm(formSettings)
);

export { Login };

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.js